/// <amd-module name="SuiteCommerce.PagePrinter.Common.InstrumentationHelper"/>
define("SuiteCommerce.PagePrinter.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.PagePrinter.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QueueNameSuffix = '-PagePrinter';
    var ExtensionVersion = '1.0.1';
    var ComponentArea = 'SC Product Page Printer';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
